// host page for the list of all Experimental Data
// fetch the information from the server

import React from 'react';


class VirtualSMLM extends React.Component {
    constructor(props){
        super(props)
    }

    render(){
        return (
            <div>
                <ul>
                    <li>
                        Description of virtual SMLM (paper abstract?) and illustration
                    </li>
                    <li>
                        Link to publication and software
                    </li>
                </ul>
            </div>
        )
    }

}

export default VirtualSMLM;
